<template>
  <div>
    <loader v-if="loading"></loader>
    <div v-if="!loading">
      <component-header
        title="Order Preference"
        :hasCreate="false"
        :hasSearch="false"
        :hasReload="false"
      />
      <div class="account-pages">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-6">
              <div class="card">
                <div class="card-body p-4">
                  <div class="form-group">
                    <b-form-group class="mt-1 ml-3">
                      <b-form-checkbox
                        type="checkbox"
                        size="lg"
                        v-model="notifySellerOrderOnly"
                      >
                        <strong class="ml-2"
                          >Self Manage</strong
                        >
                      </b-form-checkbox>
                    </b-form-group>
                  </div>
                  <div class="form-group mt-1">
                    <div class="text-center mt-3">
                      <button
                        type="button"
                        class="btn btn-primary"
                        classic="mr-1 btn-primary"
                        text="Save"
                        btn-color="primaryx"
                        @click="saveOrderPref()"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loader from "@/components/loader/nipigeloader.vue";
import ComponentHeader from "@/components/componentNewHeader";
import currentUserData from "@/mixins/currentUser";
import { mapGetters } from "vuex";
export default {
  name: "OrderPreference",
  components: {
    ComponentHeader,
    loader,
  },
  mixins: [currentUserData],
  data() {
    return {
      loading: false,
      notifySellerOrderOnly: false,
      currentUserData: "",
    };
  },
  methods: {
    async saveOrderPref() {
      try {
        let payload = {
          order:
          {
             selfManage: this.notifySellerOrderOnly
           },
        };
        let payloadFinal = {
          id: this.currentUserData._id,
          data: payload,
        };
        await this.$store
          .dispatch(
            "partner/updatePartnerPaymentPreferencesAction",
            payloadFinal
          )
          .then((res) => {
            this.$swal({
              title: "Success",
              text: "Order Preferences Set Successfully!",
              type: "success",
            });
            if (this.$route.fullPath == "/myaccount/order-preference") {
              this.$router.push("/myaccount");
            }
          })
          .catch((err) => {
            this.$swal({
              title: "Error",
              text: "Can not set order preferences",
              type: "error",
            });
          });
      } catch {
        this.$swal({
          title: "Error",
          text: "Please fillup required fields.",
          type: "error",
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      getPreferences: "partner/getPartnerPaymentPreferencesGetter",
      partnerAllData: "partner/GetPartnerData",
    }),
  },

  async mounted() {
    this.loading = true;

    if (this.$route.fullPath == "/myaccount/order-preference") {
      this.currentUserData = this.$currentUserData;
    } else {
      this.currentUserData = {
        ...this.partnerAllData,
        ...this.partnerAllData.authentication,
      };
    }
    let tenantDetails = await this.$store.dispatch(
      "tenant/getTenantDetailByID",
      this.currentUserData.tenant
    );
    await this.$store.dispatch(
      "partner/getPartnerPaymentPreferencesAction",
      this.currentUserData._id
    );
    try {
      if (this.getPreferences.preferences) {
        this.notifySellerOrderOnly = this.getPreferences.preferences.order
          .selfManage
          ? this.getPreferences.preferences.order.selfManage
          : false;
      } else {
      }
    } catch {}
    this.loading = false;
  },
};
</script>
<style>
[btn-color="primaryx"] {
  height: 39px;
  width: 120px;
  background-color: var(--primary);
  font-weight: 600;
  font-size: medium;
  letter-spacing: 2px;
  font-family: 'Lato';
  color: white;
  border: 0px;
  text-align: center;
  border-radius: 0px;
}
</style>
